const getCssVariable = name =>
	getComputedStyle(document.documentElement)
		.getPropertyValue(name)
		.trim()

const WHITE = '#FFFFFF'
const BLUE = getCssVariable('--background-confirm-secondary')
const SIMPLEGRAY = '#2B2B2B'
const PLACEHOLDERGRAY = '#5E5E5E'
const INPUTGRAY = '#CECECE'
const GRAY = '#666666'
const GREEN = '#78BF3F'
const DARKGREEN = '#458F0A'
const DANGER = '#CC4F4F'
const PRIMARY_COLOR = getCssVariable('--primary-color')
const SECUNDARY_COLOR = getCssVariable('--secondary-color')
const TEXT_PRIMARY = getCssVariable('--text-primary')
const BACKGROUND = getCssVariable('--background')
const DARKYELLOW = '#FCAE47'
const DARKGRAY = '#5D5D5D'
const DARKBLUE = '#1E5799'
const DISABLED = '#F6F7F9'
const SOFTBLUE = '#00A2E8'
const LIGHTBLUE = '#779ad4'
const LIGHTGRAY = '#C3C3C3'
const DARKORANGE = '#D9442A'
const MEDIUMGRAY = '#979797'
const LIGHTERGRAY = '#F7F7F9'
const CLEARGRAY = '#F3F3F3'
const PRIMARY_LIGHT = getCssVariable('--primary-light-color')
const MEDIUMORANGE = '#FFA42D'
const STRONGORANGE = '#F26127'
const LIGHTYELLOW = '#FDCF03'
const SOFTYELLOW = '#F9BF2B'
const SOFTGRAY = '#DDDDDD'
const RED = '#9D0000'
const SILVER = '#DADADA'
const DARKBLUE_PLANALTO = '#00285a'
const BACKGROUNDBLACKFRIDAYHEADER = '#000000'
const FONTYELLOWBLACKFRIDAYHEADER = '#FFD017'
const LOGO_FIRST_COLOR = getCssVariable('--logo-first-color')
const LOGO_CENTER_COLOR = getCssVariable('--logo-center-color')
const LOGO_LAST_COLOR = getCssVariable('--logo-last-color')
const BACKGROUND_FREE_SEAT = getCssVariable('--background-free-seat')
const TEXT_PRIVATE_MENU = getCssVariable('--text-private-menu')
const BACKGROUND_MUVICARD = getCssVariable('--background-muvicard')
const BTN_CONFIRM_COLOR_PRIMARY = getCssVariable('--btn-confirm-color-primary')
const BTN_CONFIRM_COLOR_SECONDARY = getCssVariable('--btn-confirm-color-secondary')
const BTN_CANCEL_COLOR = getCssVariable('--btn-cancel-color')
const BACKGROUND_CONFIRM_PRIMARY_COLOR = getCssVariable('--background-confirm-primary')
const BACKGROUND_CONFIRM_SECONDARY_COLOR = getCssVariable('--background-confirm-secondary')
const BTN_CANCEL_COLOR_PRIMARY = getCssVariable('--btn-cancel-color-primary')
const BTN_CANCEL_COLOR_SECONDARY = getCssVariable('--btn-cancel-color-secondary')
const BTN_REBOOKING_COLOR_PRIMARY = getCssVariable('--btn-rebooking-color-primary')
const BTN_REBOOKING_COLOR_SECONDARY = getCssVariable('--btn-rebooking-color-secondary')

export {
	BLUE,
	GRAY,
	GREEN,
	DARKGREEN,
	DANGER,
	PRIMARY_COLOR,
	SECUNDARY_COLOR,
	TEXT_PRIMARY,
	BACKGROUND,
	DARKYELLOW,
	DARKBLUE,
	DISABLED,
	LIGHTBLUE,
	LIGHTGRAY,
	DARKORANGE,
	MEDIUMGRAY,
	LIGHTERGRAY,
	PRIMARY_LIGHT,
	MEDIUMORANGE,
	STRONGORANGE,
	SIMPLEGRAY,
	LIGHTYELLOW,
	SOFTYELLOW,
	SOFTBLUE,
	SOFTGRAY,
	WHITE,
	RED,
	SILVER,
	PLACEHOLDERGRAY,
	INPUTGRAY,
	DARKGRAY,
	CLEARGRAY,
	DARKBLUE_PLANALTO,
	BACKGROUNDBLACKFRIDAYHEADER,
	FONTYELLOWBLACKFRIDAYHEADER,
	LOGO_FIRST_COLOR,
	LOGO_CENTER_COLOR,
	LOGO_LAST_COLOR,
	BACKGROUND_FREE_SEAT,
	TEXT_PRIVATE_MENU,
	BACKGROUND_MUVICARD,
	BTN_CONFIRM_COLOR_PRIMARY,
	BTN_CONFIRM_COLOR_SECONDARY,
	BTN_CANCEL_COLOR,
	BACKGROUND_CONFIRM_PRIMARY_COLOR,
	BACKGROUND_CONFIRM_SECONDARY_COLOR,
	BTN_CANCEL_COLOR_PRIMARY,
	BTN_CANCEL_COLOR_SECONDARY,
	BTN_REBOOKING_COLOR_PRIMARY,
	BTN_REBOOKING_COLOR_SECONDARY
}
